import { useRSO } from "@/api/services/main/rso";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { RsoForm } from "@/features/rso/components/RsoForm";
import { convertRsoToRsoForm } from "@/features/rso/utils/rsoConverts";

const RsoEdit = () => {
  const { data: rsoResponse, isLoading } = useRSO();
  const rsoData = rsoResponse?.data;

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!rsoData) return null;
  return <RsoForm defaultValues={convertRsoToRsoForm(rsoData)} rsoData={rsoData} />;

};

export default RsoEdit;
